import { formatDocument, formatPhone } from '../../common/formatters';

/**
 * Apoio comum das telas mobile de Clientes (`prototipos-mobile/clientes/*`).
 * Só apresentação: iniciais, cor do avatar e textos de apoio.
 */

export const isEnterprise = (type) => String(type || '').toLowerCase() === 'pj';

export const typeLabel = (type) => (isEnterprise(type) ? 'Pessoa jurídica' : 'Pessoa física');

// Iniciais das duas primeiras palavras — igual ao avatar do protótipo ("MO", "AP" de "Auto Peças Silva").
export function customerInitials(name) {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    return (parts[0][0] + (parts.length > 1 ? parts[1][0] : '')).toUpperCase();
}

// Pessoa jurídica = verde (como "Auto Peças Silva"); pessoa física alterna soft/roxo/âmbar/vermelho.
const PERSON_TONES = ['soft', 'purple', 'amber', 'red'];

export function avatarTone(name, type) {
    if (isEnterprise(type)) return 'green';
    const text = String(name || '');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) % 997;
    return PERSON_TONES[hash % PERSON_TONES.length];
}

// Linha de apoio do item da lista: "(11) 98765-4321 · Pessoa física" ou "CNPJ 12.345.678/0001-90".
export function customerSubtitle(customer) {
    const phone = formatPhone(customer.Cellphone);
    if (isEnterprise(customer.CustomerType)) {
        const doc = formatDocument(customer.Document);
        if (doc) return `CNPJ ${doc}`;
        return phone ? `${phone} · ${typeLabel(customer.CustomerType)}` : typeLabel(customer.CustomerType);
    }
    return phone ? `${phone} · ${typeLabel(customer.CustomerType)}` : typeLabel(customer.CustomerType);
}
